import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import 'rxjs/add/operator/debounceTime';
import { Subscription } from 'rxjs/Subscription';
import { DataService } from '../../services/data.service';

import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { locale as translationEnglish } from './i18n/en';
import { locale as translationRussian } from './i18n/ru';

@Component({
    selector     : 'fuse-quick-panel',
    templateUrl  : './quick-panel.component.html',
    styleUrls    : ['./quick-panel.component.scss'],
    encapsulation: ViewEncapsulation.None
})
export class FuseQuickPanelComponent implements OnInit, OnDestroy
{
    date: Date;
    loggedIdSub: Subscription;
    shakeBell = false;
    reminders: Array<any> = new Array<any>();
    count = 15;
    needDownLoad: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
    showSpinner = false;
    totalEvents = 0;

    constructor(private dataService: DataService, private fuseTranslationLoader: FuseTranslationLoaderService)
    {
      this.fuseTranslationLoader.loadTranslations(translationEnglish, translationRussian);

        this.date = new Date();
        this.loggedIdSub = this.dataService.isLoggedIn.subscribe((loggedIn) => {
            if (loggedIn) {
              this.loadReminders();
            }
          });
          this.dataService.reminder.subscribe((event: any) => {
            if (event) {
              this.reminders.unshift(event);
              this.totalEvents++;
              this.dataService.remindersCount.next({count: this.totalEvents, shake: true});
            }
          });
          this.needDownLoad.debounceTime(500).subscribe(res => {
            if (res) {
              this.loadReminders();
            }
          });
    }

    ngOnInit()
    {
      console.log('init quick-panel component');
    }

    onScrollEvent(e) {
        if (!this.showSpinner && this.totalEvents !== this.reminders.length) {
            this.showSpinner = true;
            this.needDownLoad.next(true);
        }
    }
    

    loadReminders() {
        this.dataService.getNotifications(this.count, this.reminders.length).subscribe((res: any) => {
            this.showSpinner = false;
            //  console.log(res);
            if (res && !res.errors) {
                this.totalEvents = res.data.count;
                this.dataService.remindersCount.next({count: this.totalEvents, shake: false});
                for (let i = 0; res.data.notifications.length > i; i++) {
                    if (!this.reminders.find(r => r.id === res.data.notifications[i].id)) {
                        this.reminders.push(res.data.notifications[i]);
                    }
                }
            } else {
              // console.error(res);
            }
        });
    }

    deleteNotification(id) {
        this.dataService.deleteNotification(id).subscribe((res: any) => {
          if (res && !res.errors) {
            this.totalEvents--;
            this.dataService.remindersCount.next({count: this.totalEvents, shake: false});
            this.reminders = this.reminders.filter((item: any) => {
              if (item.id !== id) {
                return item;
              }
            });
          }
        });
      }

      ngOnDestroy() {
        this.loggedIdSub.unsubscribe();
        this.totalEvents = 0;
        this.reminders = [];
      }
}



// WEBPACK FOOTER //
// ./src/app/main/quick-panel/quick-panel.component.ts